// extracted by mini-css-extract-plugin
export default {"sectionTitle":"ndEAt","newSectionTitle":"_2Yw5x"};